/**
 * About Page
 * 
 * Main about page for the Boardgames Today application.
 * Contains information about the company and the visual dictionary.
 */
import VisualDictionary from '../../components/about/visual-dictionary'

function AboutPage() {
  return (
    <div className="space-y-8">
      <section className="border-b pb-8">
        <h1 className="text-4xl font-bold mb-4">About Boardgames Today</h1>
        <p className="text-lg text-muted-foreground">
          Your premier destination for discovering board games, connecting with players,
          and finding local gaming events.
        </p>
      </section>
      
      <VisualDictionary />
    </div>
  )
}

export default AboutPage
